module.exports = __webpack_public_path__ + "img/ug.fb0df90b.png";